import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { withAutoBlur } from '../../../utils/misc'
import { useConfigurationStore } from '@stores'

interface SideButtonProps {
    id: string
    isActive: boolean
    onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void
    isInteractive?: boolean
    texture: string
    className?: string
    shouldUpdateOpacityWhenInactive?: boolean
    disableAutoBlur?: boolean
    pulse?: boolean
}

const SideButton: React.FC<SideButtonProps> = ({
    id,
    isActive,
    isInteractive = true,
    onClick,
    texture,
    className = '',
    shouldUpdateOpacityWhenInactive = true,
    disableAutoBlur = false,
    pulse,
}) => {
    const handleClick = disableAutoBlur ? onClick : withAutoBlur(onClick)
    const buttonRef = useRef<HTMLButtonElement>(null)
    const configStyles = useConfigurationStore((state) => state.getComponentConfig('SideButton').styles)

    useEffect(() => {
        const button = buttonRef.current

        if (!button) return

        if (pulse) {
            const tween = gsap.to(button, {
                scale: 1.1,
                duration: 0.5,
                filter: 'brightness(1.25)',
                ease: 'power2.inOut',
                repeat: -1,
                yoyo: true,
            })

            return () => {
                tween.kill()
                gsap.to(button, {
                    scale: 1,
                    filter: 'brightness(1)',
                    duration: 0.3,
                    ease: 'power2.out',
                })
            }
        }
    }, [pulse])

    return (
        <>
            <button
                ref={buttonRef}
                id={id}
                className={`w-[120px] h-[120px] focus:outline-none brightness-100 rounded-full overflow-hidden
                    ${configStyles}
                    ${isActive ? '' : `${shouldUpdateOpacityWhenInactive ? 'opacity-50' : ''} pointer-events-none`}
                    ${isInteractive ? '' : 'pointer-events-none'}
                    ${className}`}
                onClick={handleClick}
            >
                <img src={texture} alt="Bet Option Button" className="w-full h-full" />
            </button>
        </>
    )
}

export default SideButton
